import useAppMutation from 'hooks/useAppMutation';
import useNotify from 'hooks/useNotify';
import { ICal } from 'models/ICal';
import { useTranslation } from 'react-i18next';
import API from 'services/API';
import { getErrorMessage } from 'utils/axiosExceptionUtils';

export const CREATE_ICAL_MUTATION_KEY = ['create-ical'];

const useCreateIcal = () => {
  const { notifyError } = useNotify();
  const { t } = useTranslation();
  const { mutateAsync: createIcal } = useAppMutation({
    mutationKey: CREATE_ICAL_MUTATION_KEY,
    mutationFn: ({
      payload,
      synchronizeAfterCreation,
    }: {
      payload: ICal;
      synchronizeAfterCreation: boolean;
    }) => {
      return API.post('/api/internal/icals', payload, {
        params: {
          synchronizeAfterCreation,
        },
      });
    },
    onError: (error: any) => {
      notifyError(
        getErrorMessage({
          apiErrorCode: error?.response?.data?.apiErrorCode,
          apiErrorMessage: error?.response?.data?.apiErrorMessage,
          baseKey:
            'pageAutomations.calendarTools.calendarImportSection.apiErrorCodes.',
          t,
        }),
      );
    },
  });

  return {
    createIcal,
  };
};

export default useCreateIcal;
